export interface LevelConfig {
  id: number
  name: string
}

export const LEVEL_POINTS_THRESHOLDS: Record<number, number> = {
  1: 1,
  2: 6,
  3: 31,
  4: 131,
  5: 331,
  6: 731,
  7: 1531,
  8: 3131,
  9: 6331,
  10: 12731
}

export const LEVELS_CONFIG: LevelConfig[] = [
  { id: 1, name: 'Song Starter' },
  { id: 2, name: 'Chord Finder' },
  { id: 3, name: 'Rhythm Keeper' },
  { id: 4, name: 'Melody Shaper' },
  { id: 5, name: 'Harmony Builder' },
  { id: 6, name: 'Verse Crafter' },
  { id: 7, name: 'Bridge Maker' },
  { id: 8, name: 'Sound Architect' },
  { id: 9, name: 'Spirit Lifter' },
  { id: 10, name: 'Legacy Bearer' }
]

export const getLevelConfig = (level: number): LevelConfig | undefined =>
  LEVELS_CONFIG.find((entry) => entry.id === level)

export const getLevelTitle = (level: number): string => {
  if (level === 0) {
    return 'Level 0'
  }

  return `Level ${level} - ${getLevelConfig(level)!.name}`
}

export interface LevelWithStatus extends LevelConfig {
  isUnlocked: boolean
}

export const getLevelsWithStatus = (currentLevel: number): LevelWithStatus[] =>
  LEVELS_CONFIG.map((level) => ({
    ...level,
    isUnlocked: currentLevel >= level.id
  }))
